export default __webpack_public_path__ + "static/media/webrtc.ea0713cd.svg";